module.exports = __webpack_public_path__ + "img/bg-image-20.9ab7c605.jpg";